import React from 'react';
import ToastHost from './ToastHost';
import ConfirmHost from './ConfirmHost';

// Mounted once in App.js inside the ThemeProvider. Hosts the toast and the
// confirm dialog that showToast() / confirmDialog() talk to.
export default function FeedbackProvider({ children }) {
  return (
    <>
      {children}
      <ToastHost />
      <ConfirmHost />
    </>
  );
}
